import { render, staticRenderFns } from "./ViTeacherAcademicManagementAssignments.vue?vue&type=template&id=3dbde59e"
import script from "./ViTeacherAcademicManagementAssignments.vue?vue&type=script&lang=js"
export * from "./ViTeacherAcademicManagementAssignments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports